import { pick } from 'ramda'
import { applyMiddleware, compose, createStore } from 'redux'
import persistState from 'redux-localstorage'
import thunkMiddleware from 'redux-thunk'
import { errorActions } from './api/apiUtils'
import errorMiddleware from './middlewares/errorMiddleware'
import { refreshTokenMiddleware } from './middlewares/refreshTokenMiddleware'
import reducers from './reducers'

const middlewares = [refreshTokenMiddleware, errorMiddleware(errorActions), thunkMiddleware]

if (process.env.NODE_ENV === `development`) {
    const { logger } = require(`redux-logger`)
    middlewares.push(logger)
}

// cuts all "auth" data from localStorage except "token"
const slicer = paths => state => ({
    ...pick(paths, state),
    auth: { token: state.auth.token }
})

const store = createStore(
    reducers,
    compose(
        persistState(
            [
                'auth',
                'bookingCurrentOrganization',
                'h24CurrentOrganization',
                'hwCurrentOrganization',
                'dobovoCurrentOrganization',
                'expediaCurrentOrganization'
            ],
            { slicer }
        )
    ),
    applyMiddleware(...middlewares)
)
export default store



// WEBPACK FOOTER //
// ./src/store.js